import AttorneyBioTemplate from '@/components/AttorneyBioTemplate';
import { attorneys } from '@/data/attorneys';

export default function GabriellaVaitzmanPage() {
  return <AttorneyBioTemplate attorney={attorneys['gabriella-vaitzman-esq']} />;
}
